let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6vzdH"), load("9V9Fn"), load("1zoBu")]).then(() => parcelRequire('4QNfT'));